import React, { useState, useEffect } from "react";
import { DefaultWidgetContextMenu } from "../../components/DefaultWidgetContextMenu";
import { FloatingLabelContainer } from "../../components/FloatingLabel";

// Externals
import cn from "classnames";

// DevExtreme components
import { NumberBox } from 'devextreme-react/number-box';

// Component styles
import classes from "./NumberWidget.module.scss";

const EMPTY = undefined;

export function NumberWidget(props) {
  const { ui, config, data, writeBack, startWork, useFloatingLabel } = props;

  const [localContent, setLocalContent] = useState(EMPTY);
  const [hasFocus, setHasFocus] = useState(false);

  let widgetId = ui.id;

  let f = config ? config.Format : null;
  let u = config ? config.Unit : null;
  let format = (f && u) ? (f + " " + u) : (f ? f : u);

  let content = localContent !== EMPTY ? localContent : data && data.content ? parseFloat(data.content) : null;
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("NumberWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = value => {
    setLocalContent(value);
    writeBack(value ? value.toString() : null);
  };

  const handleOnCopy = () => {
    return content;
  };

  const handleOnPaste = (value) => {
    setLocalContent(value);
    writeBack(value ? value.toString() : null, true);
  };

  const handleOnDelete = () => {
    setLocalContent(null);
    writeBack(null, true);
  };

  return (
    <DefaultWidgetContextMenu
      widgetId={widgetId}
      onCopy={handleOnCopy}
      onPaste={handleOnPaste}
      onDelete={handleOnDelete}
      editable={!disabled}
    >
      <FloatingLabelContainer condition={useFloatingLabel} widgetId={widgetId} hasContent={content} hasFocus={hasFocus} text={ui.label}>
        <NumberBox
          className={cn(classes.numberBox, useFloatingLabel ? classes.withFloatingLabel : "", disabled ? classes.disabled : "")}
          id={widgetId}
          value={content}
          onFocusOut={() => setHasFocus(false)}
          onFocusIn={() => setHasFocus(true)}
          format={format}
          //showSpinButtons={true}
          onKeyUp={() => startWork()}
          onValueChanged={e => setContent(e.value)}
          disabled={disabled}
          height={ui.controlHeight + "em"}
        />
      </FloatingLabelContainer>
    </DefaultWidgetContextMenu>
  );
}
